import React from "react";
import { useFormContext } from "react-hook-form";
import NumberValue, { NumberValueProps } from "../NumberValue/NumberValue";

function DayValue(props: NumberValueProps) {
  const { type, prefixName } = props;
  const { trigger } = useFormContext();
  const name =
    type === "number[]"
      ? `${prefixName}.value.value[0]`
      : `${prefixName}.value.value`;

  const validateIntNumber = (value?: any) => {
    if (value && typeof value === "number" && value % 1 !== 0) {
      return "Please enter a number without decimal point";
    }
  };

  React.useEffect(() => {
    trigger([name]);
  }, [trigger, name]);

  return (
    <NumberValue
      {...props}
      placeholder="Days"
      min={1}
      max={730}
      validate={validateIntNumber}
    />
  );
}

export default DayValue;
